module.exports = __webpack_public_path__ + "static/media/experience.a00ede3f.svg";